module.exports = __webpack_public_path__ + "media/packs/static/fonts/icon/font-9d955f49c573da71ab6dff79e9bb2eed.ttf";